package app.smartcoding.realrate.presentation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.Stable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import app.smartcoding.realrate.domain.model.AuthUser
import app.smartcoding.realrate.platform.SignIn
import app.smartcoding.realrate.platform.ensureUserIsSignedIn
import app.smartcoding.realrate.platform.firebaseSignOut
import kotlinx.coroutines.launch

@Stable
class AuthViewModel : ViewModel() {
    var authUser: AuthUser by mutableStateOf(AuthUser.Unknown)
        private set
    var authenticationAccount by mutableStateOf(false)
        private set

    init {
        viewModelScope.launch {
            ensureUserIsSignedIn { authUser = it }
        }
    }

    @Composable
    fun SignIn(
        onSuccess: (user: AuthUser) -> Unit,
        onFailure: (Throwable) -> Unit
    ) {
        SignIn(
            authenticationAccount = authenticationAccount,
            onSuccess = { user ->
                authUser = user
                onSuccess(user)
            },
            onFailure = { error ->
                authenticationAccount = false
                onFailure(error)
            }
        )
    }

    @Composable
    fun SignOut(
        onSuccess: () -> Unit = {},
        onFailure: (Throwable) -> Unit = {}
    ) {
        LaunchedEffect(Unit) {
            try {
                firebaseSignOut()
                ensureUserIsSignedIn {
                    authUser = it
                    onSuccess()
                }
            } catch (e: Exception) {
                onFailure(e)
            }
        }
    }
}